import * as Sentry from '@sentry/react';

import { isRouteErrorResponse, useRouteError } from 'react-router';
import { LoginRequired, ServiceUnavailable, UserNotFound } from '@/exceptions';
import ErrorLayout from '@/app/ErrorLayout';

/**
 * エラー画面の振り分け
 */
export default function ErrorBoundary() {
  const error = useRouteError();

  // 4xx、5xx系
  if (isRouteErrorResponse(error)) {
    // Sentryにエラーを送出
    if (error) {
      Sentry.captureException(error);
    }

    return (
      <ErrorLayout>
        <div>
          <h1 className="text-2xl text-gray-600 italic font-footballlog">
            {error.status} {error.statusText}
          </h1>
          {import.meta.env.DEV && <p className="text-gray-600">{error.data}</p>}
        </div>
      </ErrorLayout>
    );
    // ユーザーが見つからない（退会ユーザー等）
  } else if (error instanceof UserNotFound) {
    return (
      <ErrorLayout>
        <div>
          <h1 className="text-2xl text-gray-600 italic font-footballlog">access denied</h1>
        </div>
      </ErrorLayout>
    );
    // システムメンテナンス
  } else if (error instanceof ServiceUnavailable) {
    return (
      <ErrorLayout>
        <div>
          <p className="text-gray-600">システムメンテナンス中です。</p>
        </div>
      </ErrorLayout>
    );
    // 要ログイン
  } else if (error instanceof LoginRequired) {
    return (
      <ErrorLayout>
        <div>
          <p className="mb-4 text-gray-600">ログインが必要です。</p>
          <button
            type="button"
            className="text-gray-600 underline underline-offset-4 hover:text-blue-500"
            onClick={() => window.location.replace(import.meta.env.VITE_FOOTBALLLOG_LOGIN_PATH || '')}>
            ログインはこちら
          </button>
        </div>
      </ErrorLayout>
    );
    // 通常の例外
  } else if (error instanceof Error) {
    // Sentryにエラーを送出
    if (error) {
      Sentry.captureException(error);
    }

    return (
      <ErrorLayout>
        <div>
          <p className="mb-4 text-gray-600">
            oops something went wrong...
            <br />
            please try again later.
          </p>
          {/* <button
            type="button"
            className="underline underline-offset-4 hover:text-blue-500"
            onClick={() => window.location.replace('/home')}>
            back to Home
          </button> */}
          <button
            type="button"
            className="text-gray-600 underline underline-offset-4 hover:text-blue-500"
            onClick={() => window.location.reload()}>
            retry
          </button>
        </div>
        {import.meta.env.DEV && (
          <>
            <div className="mt-8">
              <pre>{error.message}</pre>
            </div>
            <div className="mt-8">
              <p>The stack trace is:</p>
              <pre>{error.stack}</pre>
            </div>
          </>
        )}
      </ErrorLayout>
    );
    // その他
  } else {
    return <ErrorLayout>Unknown Error</ErrorLayout>;
  }
}
